import React, { Component } from "react";
import PropTypes from "prop-types";
import "bootstrap";
import { connect } from "react-redux";
import * as actions from "../../actions/loginActions";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { getUrlByMenuItem } from "./Routes";
import LanguageChanger from "@mnjsplatform/data/lib/api/LanguageChanger";
import {errorRaised} from "@mnjsplatform/data/lib/actions/errorActions";
import PopupWrapper from "@mnjsplatform/components/lib/common/PopupWrapper";
import i18next from "i18next";

class Menu extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      languageChangerVisible: false
    };
  }

  logout = () => {
    this.props.dispatch(actions.logout(this.props.history));
  };

  changeLanguage(e, lcid, langCode) {
    e.preventDefault();
    LanguageChanger.setLanguage(lcid, langCode, "CarrierHome")
      .catch(ed => this.props.dispatch(errorRaised(ed)));
  }

  showLanguageChanger = (e) => {
    e.preventDefault();
    this.setState({ languageChangerVisible: true });
  };

  hideLanguageChanger = () => {
    this.setState({ languageChangerVisible: false });
  };

  renderLangRows = () => {
    if (!this.props.appState.languages) {
      return null;
    }

    let currentLanguageId = this.props.appState.languageId;
    if (currentLanguageId > 1024) {
      currentLanguageId -= 1024;
    }

    return this.props.appState.languages.map((row, idx) => {
      const className = (row.LangId === currentLanguageId) ? "dropdown-item selected" : "dropdown-item";
      return (
        <li role="presentation" key={idx}>
          <a className={className}
             href=""
             onClick={(e) => this.changeLanguage(e, row.LangId, row.LangName)}
          >
            {row.LangName}
          </a>
        </li>
      );
    });
  };

  render() {
    return (
      <React.Fragment>
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
          <span className="navbar-brand" style={{marginRight: '50px', color: '#BBBBBB'}}>{this.props.appState.workplaceTitle}</span>

          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"/>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
              {this.props.appState.menu.Items.map(mi => this.renderMenuItem(mi))}
            </ul>
            <ul className="navbar-nav float-right">
              <li className="nav-item dropdown" >
                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                   aria-haspopup="true" aria-expanded="false"
                >
                  {i18next.t("LoginNoun")}:&nbsp;{this.props.appState ? this.props.appState.login : ""}
                  &nbsp;<i className="zmdi zmdi-chevron-down"></i>
                </a>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <Link className="dropdown-item" to="/ChangePassword">{i18next.t("ChangePassword")}</Link>
                  <div className="dropdown-item c-pointer" onClick={this.showLanguageChanger}>{i18next.t("ChangeLanguage")}</div>
                  {this.props.appState.enableExternalApi && <Link className="dropdown-item" to="/ApiAccess">{i18next.t("ApiAccess")}</Link>}
                  {this.props.appState.enableHelp && <Link className="dropdown-item" to="/ApiHelp">{i18next.t("HelpApiForm")}</Link>}
                </div>
              </li>
            </ul>
            <button className="btn btn-input" onClick={this.logout}>{i18next.t("Logout")}</button>
          </div>
        </nav>
        <div style={{textAlign: 'right'}}>
          <span style={{fontSize: '12px', color: 'gray', marginRight: '15px'}}>
            <dfn>{i18next.t("LoginNoun")}:&nbsp;{this.props.appState ? this.props.appState.login : ""}&nbsp;&nbsp;&nbsp;{i18next.t("Version")}:&nbsp;{process.env.REACT_APP_VERSION_NUMBER}</dfn>
          </span>
        </div>

        <PopupWrapper onClose={this.hideLanguageChanger}
                      popupVisible={this.state.languageChangerVisible}
                      title={i18next.t("LanguageChanging")}
        >
          <ul style={{listStyleType: "none"}}>
            {this.renderLangRows()}
          </ul>
        </PopupWrapper>
      </React.Fragment>
    );
  }

  renderMenuItem(menuItem) {

    if (!!menuItem.ParentID || !menuItem.IsVisible)
      return null;

    if (menuItem.Type === 0) {
      return (<li className="nav-item" key={menuItem.MenuID}>
        <Link className="nav-link" to={getUrlByMenuItem(menuItem)}>{menuItem.Text}</Link>
      </li>);
    } else if (menuItem.Type === 1) {
      const childMenuItems = this.getChildItems(menuItem);
      return (<li className="nav-item dropdown" key={menuItem.MenuID}>
        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
           aria-haspopup="true" aria-expanded="false">
          {menuItem.Text}
        </a>
        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
          {childMenuItems.map(mi => {
            if (menuItem.Type === 2)
              return (<div className="dropdown-divider" key={mi.MenuID}/>);
            else return (<Link className="dropdown-item" to="#" key={mi.MenuID}>{mi.Text}</Link>);
          })}
        </div>
      </li>);
    }
  }

  getChildItems(menuItem) {
    return this.props.appState.menu.Items.filter(mi => mi.ParentID === menuItem.MenuID && mi.IsVisible && mi.Type === 0);
  }
}

Menu.propTypes = {
  dispatch: PropTypes.func.isRequired,
  appState: PropTypes.object
};


Menu.defaultProps = {
  //myProp: <defaultValue>
};

//    auctionBidMode: state.appState.appParams.auctionBidMode
function mapStateToProps(state) {
  return {
    appState: state.appState.appParams
  };
}

export default withRouter(connect(mapStateToProps)(Menu));